module.exports = __webpack_public_path__ + "media/images/NCPC-photo-ea2303a8f17022ee0db8c54f4ced4881.jpg";